import { createSelector } from 'reselect';

export const selectedPendingClaims = (state: any) => {
  return state.get('managerPendingClaims');
};

const makeSelectPendingClaims = () =>
  createSelector(selectedPendingClaims, claims => {
    if (claims && claims.get('claims')) {
      return claims.get('claims').toJS();
    }
    return [];
  });

const makeSelectCountPendingClaims = () =>
  createSelector(selectedPendingClaims, claims => {
    if (claims && claims.get('countClaims')) {
      return claims.get('countClaims');
    }
    return 0;
  });

export { makeSelectPendingClaims, makeSelectCountPendingClaims };
